/*
  +--------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     一物一码 API 接口
  +--------------------------------------------------------------------------------------
*/
import request from '@/utils/request'
const generalApiHost = process.env.VUE_APP_GENERAL_API_HOST;

export function overviewApi(params) {
  return request({
    url: generalApiHost + '/oioc/overview',
    method: 'get',
    params
  })
}


export function productListApi(params) {
  return request({
    url: generalApiHost + '/oioc/product/list',
    method: 'get',
    params
  })
}

export function productGetallApi(params) {
  return request({
    url: generalApiHost + '/oioc/product/getAll',
    method: 'get',
    params
  })
}

export function productPostApi(data) {
  return request({
    url: generalApiHost + '/oioc/product/post',
    method: 'post',
    data
  })
}

export function productDeleteApi(data) {
  return request({
    url: generalApiHost + '/oioc/product/delete',
    method: 'post',
    data
  })
}

export function codeListApi(params) {
  return request({
    url: generalApiHost + '/oioc/code/list',
    method: 'get',
    params
  })
}

export function codeStatApi(params) {
  return request({
    url: generalApiHost + '/oioc/code/count/stat',
    method: 'get',
    params
  })
}

export function codeGenerateApi(data) {
  return request({
    url: generalApiHost + '/oioc/code/generate',
    method: 'post',
    data
  })
}

export function codeDownloadApi(data) {
  return request({
    url: generalApiHost + '/oioc/code/download',
    method: 'post',
    data
  })
}

export function codeDeleteApi(data) {
  return request({
    url: generalApiHost + '/oioc/code/delete/batch',
    method: 'post',
    data
  })
}

export function codeResetApi(data) {
  return request({
    url: generalApiHost + '/oioc/code/status/reset',
    method: 'post',
    data
  })
}

export function codeDownloadDeleteApi(data) {
  return request({
    url: generalApiHost + '/oioc/code/download/delete',
    method: 'post',
    data
  })
}

export function codeActiveApi(data) {
  return request({
    url: generalApiHost + '/oioc/code/active',
    method: 'post',
    data
  })
}

export function getCheckListApi(params) {
  return request({
    url: generalApiHost + '/oioc/code/check/list',
    method: 'get',
    params
  })
}

export function codeCheckDeleteApi(data) {
  return request({
    url: generalApiHost + '/oioc/code/check/delete',
    method: 'post',
    data
  })
}
